import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { TenantProvider, loadTenantConfig } from './utils/tenant';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// Fetch tenant config and inject CSS vars before first render.
// loadTenantConfig() is always silent on failure and falls back to defaults.
loadTenantConfig().then((config) => {
  createRoot(rootElement).render(
    <StrictMode>
      <TenantProvider config={config}>
        <App />
      </TenantProvider>
    </StrictMode>
  );
});
